<template>
	<div class="code-area">
		<div style="margin-top: 40px;text-align: center;">
			<div>扫一扫付款</div>
			<div class="price-number">{{price}}元</div>
			<vue-qr :logoSrc="imageUrl" :text="codeUrl" :size="250"></vue-qr>
			<div style="display: flex;align-items: center;justify-content: center;margin-top: 15px;">
				<i style="color: #F6C47F;font-size: 30px;margin-right: 5px;font-weight: 600;"
					class="el-icon-full-screen"></i>
				<div>打开手机微信扫一扫付款</div>
			</div>
			<div style="margin-top: 30px;color: red;">
				<div v-if="tips=='未支付'">
					<i class="el-icon-loading"></i>支付中...
				</div>
				<div v-if="tips=='支付成功'">
					<i class="el-icon-circle-check"></i>
					支付成功
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		orderStatus
	} from "@/api/lesson";
	import vueQr from "vue-qr";
	export default {
		data() {
			return {
				imageUrl: require("@/assets/images/wechat.png"),
				codeUrl: null,
				price: null,
				timer: null,
				countDownTime: null,
				tips: ''
			};
		},
		components: {
			vueQr,
		},
		created() {
			this.codeUrl = this.$route.query.code
			this.price = this.$route.query.price
			if (window.sessionStorage.getItem("pay_time") == null) {
				this.countDownTime = 300
				this.startCountDown();
			} else {
				this.countDownTime = Number(window.sessionStorage.getItem("pay_time"));
				this.startCountDown();
			}
		},
		beforeDestroy() { //页面关闭时清除定时器
			clearInterval(this.timer);
			sessionStorage.removeItem("pay_time");
		},
		methods: {
			startCountDown() {
				this.timer = setInterval(() => {
					if (this.countDownTime == 0) {
						clearInterval(this.timer);
						sessionStorage.removeItem("pay_time");
						this.$message({
							showClose: true,
							type: 'error',
							message: '订单已超时！！！'
						})
						this.$router.push({
							path: "/profile",
							query: {
								type: 2
							}
						})
					}
					if (this.countDownTime > 0) {
						//每秒让countDownTime -1秒,并设置到sessionStorage中
						this.countDownTime--;
						window.sessionStorage.setItem("exam_time", this.countDownTime);
						orderStatus(this.$route.query.orderNo).then(res => {
							this.tips = res.msg
							if (res.msg == '支付成功') {
								this.$router.push({
									path: "/profile",
									query: {
										type: 2
									}
								})
							}
						})
					}
				}, 1000);
			},
		}
	};
</script>


<style scoped>
	.price-number {
		font-size: 18px;
		font-weight: 600;
		color: #F46D21;
		margin: 10px 0 15px 0;
	}

	.code-area {
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>